import { createI18n } from 'vue-i18n';

// 动态导入语言文件
function loadLocaleMessages() {
  const locales = {};
  
  // 导入中文语言文件
  const zhModules = import.meta.glob('./locales/zh/*.json', { eager: true });
  locales.zh = {};
  Object.keys(zhModules).forEach(key => {
    const moduleName = key.replace('./locales/zh/', '').replace('.json', '');
    locales.zh = { ...locales.zh, ...zhModules[key].default };
  });
  
  // 导入英文语言文件
  const enModules = import.meta.glob('./locales/en/*.json', { eager: true });
  locales.en = {};
  Object.keys(enModules).forEach(key => {
    const moduleName = key.replace('./locales/en/', '').replace('.json', '');
    locales.en = { ...locales.en, ...enModules[key].default };
  });
  
  return locales;
}

// 获取浏览器语言设置
function getBrowserLocale() {
  const navigatorLocale = navigator.languages !== undefined
    ? navigator.languages[0]
    : navigator.language;
  
  if (!navigatorLocale) {
    return 'zh';
  }
  
  // 简化语言代码 (例如: 'zh-CN' -> 'zh')
  const trimmedLocale = navigatorLocale.trim().split(/-|_/)[0];
  
  // 检查是否支持该语言
  return ['en', 'zh'].includes(trimmedLocale) ? trimmedLocale : 'zh';
}

// 从localStorage获取保存的语言设置
function getStoredLocale() {
  return localStorage.getItem('user-locale') || getBrowserLocale();
}

// 保存语言设置到localStorage
export function setLocale(locale) {
  localStorage.setItem('user-locale', locale);
  i18n.global.locale.value = locale;
}

// 获取当前语言
export function getCurrentLocale() {
  return i18n.global.locale.value;
}

// 获取所有可用语言
export function getAvailableLocales() {
  return [
    { code: 'zh', name: '中文', flag: '🇨🇳' },
    { code: 'en', name: 'English', flag: '🇺🇸' }
  ];
}

const i18n = createI18n({
  legacy: false, // 使用Composition API模式
  locale: getStoredLocale(), // 使用保存的语言或浏览器语言
  fallbackLocale: 'en', // 回退语言
  globalInjection: true, // 全局注入$t函数
  messages: loadLocaleMessages(),
  // 数字格式化
  numberFormats: {
    en: {
      currency: {
        style: 'currency',
        currency: 'USD'
      },
      decimal: {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }
    },
    zh: {
      currency: {
        style: 'currency',
        currency: 'CNY'
      },
      decimal: {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }
    }
  },
  // 日期时间格式化
  datetimeFormats: {
    en: {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      },
      long: {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        weekday: 'short',
        hour: 'numeric',
        minute: 'numeric'
      }
    },
    zh: {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      },
      long: {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        weekday: 'short',
        hour: 'numeric',
        minute: 'numeric',
        hour12: false
      }
    }
  }
});

export default i18n;